import React from 'react';

export default function AboutPage() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      padding: '2rem',
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        padding: '2.5rem',
        width: '100%',
        maxWidth: '760px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
        marginTop: '1rem',
        marginBottom: '2rem',
      }}>
        <a href="/" style={{ color: '#01696F', fontSize: '0.85rem', textDecoration: 'none' }}>&larr; Back to home</a>

        <h1 style={{ color: '#1e293b', fontSize: '1.5rem', fontWeight: '700', marginTop: '1.5rem', marginBottom: '2rem' }}>About BragSheet</h1>

        <h2 style={{ color: '#1e293b', fontSize: '1.15rem', fontWeight: '600', marginTop: '1.75rem', marginBottom: '0.5rem' }}>Our Mission</h2>
        <p style={{ color: '#475569', fontSize: '0.9rem', lineHeight: '1.7' }}>
          BragSheet helps high school students document their journey and build stronger college applications through AI-powered journaling.
        </p>

        <h2 style={{ color: '#1e293b', fontSize: '1.15rem', fontWeight: '600', marginTop: '1.75rem', marginBottom: '0.5rem' }}>The Problem</h2>
        <p style={{ color: '#475569', fontSize: '0.9rem', lineHeight: '1.7' }}>
          Students do incredible things throughout high school — leading clubs, volunteering, competing, growing — but when application season arrives, the details fade. Activities blur together, achievements go unrecorded, and the most compelling essay topics stay buried in memory.
        </p>

        <h2 style={{ color: '#1e293b', fontSize: '1.15rem', fontWeight: '600', marginTop: '1.75rem', marginBottom: '0.5rem' }}>Our Approach</h2>
        <p style={{ color: '#475569', fontSize: '0.9rem', lineHeight: '1.7' }}>
          BragSheet is a simple journal that meets students where they are. Capture achievements as they happen, use AI to find patterns and themes, and export everything when it's time to apply. No complicated setup, no steep learning curve — just write about what matters to you.
        </p>

        <h2 style={{ color: '#1e293b', fontSize: '1.15rem', fontWeight: '600', marginTop: '1.75rem', marginBottom: '0.5rem' }}>What We Believe</h2>

        <p style={{ color: '#475569', fontSize: '0.9rem', lineHeight: '1.7', marginTop: '1rem' }}>
          <strong style={{ color: '#1e293b' }}>Student privacy first</strong> — Your data belongs to you. We never sell it, and you can delete everything at any time.
        </p>

        <p style={{ color: '#475569', fontSize: '0.9rem', lineHeight: '1.7', marginTop: '1rem' }}>
          <strong style={{ color: '#1e293b' }}>AI as a tool, not a crutch</strong> — AI suggests tags and essay themes, but your voice and your story are always yours.
        </p>

        <p style={{ color: '#475569', fontSize: '0.9rem', lineHeight: '1.7', marginTop: '1rem' }}>
          <strong style={{ color: '#1e293b' }}>Accessible to all</strong> — Every student deserves tools to tell their story, regardless of background or resources.
        </p>

        <p style={{ color: '#475569', fontSize: '0.9rem', lineHeight: '1.7', marginTop: '1rem' }}>
          <strong style={{ color: '#1e293b' }}>Built for real students</strong> — We designed BragSheet based on what students actually need, not what looks good in a pitch deck.
        </p>
      </div>
    </div>
  );
}
